// Region-specific display text for form fields, keyed by regionId (see regionTimezoneMapping
// in StaticData.jsx: 1 = Netherlands, 2 = Spain, 3 = Luxembourg).
// To add another field whose label/text varies by region, add a key to REGION_LABELS
// below and export a small getter for it, following the getTaxIdLabel pattern.
const REGION_LABELS = {
  taxId: { 1: 'KvK', 2: 'N.I.F', 3: 'RCS' },
};

const getRegionLabel = (field, regionId, fallback) =>
  REGION_LABELS[field]?.[regionId] || fallback;

// Tax ID field label per region (RAT-1822): Netherlands -> KvK, Spain -> N.I.F, Luxembourg -> RCS.
export const getTaxIdLabel = (regionId) =>
  getRegionLabel('taxId', regionId, 'Tax ID');
